import { useState } from 'react';

export default function Results() {
  const [selectedDoc, setSelectedDoc] = useState<string | null>(null);

  const documents = [
    {
      id: 1,
      title: 'Cuadro de Méritos',
      description: 'Ranking completo de estudiantes con puntajes detallados por asignatura y posición general',
      image: 'https://static.readdy.ai/image/637245dcd209b8280a76b9094dfb4864/6fb909466832c5088e14a0679591200e.png',
      features: [
        'Posición de cada estudiante',
        'Puntajes por asignatura',
        'Puntaje total acumulado',
        'Formato profesional y claro'
      ]
    },
    {
      id: 2,
      title: 'Boleta de Notas',
      description: 'Reporte individual detallado con calificaciones por asignatura y mérito del estudiante',
      image: 'https://static.readdy.ai/image/637245dcd209b8280a76b9094dfb4864/d0c757041104ee353f5730011557b71d.png',
      features: [
        'Datos completos del estudiante',
        'Notas por asignatura',
        'Respuestas correctas, incorrectas y en blanco',
        'Mérito del aula calculado'
      ]
    }
  ];

  return (
    <section id="resultados" className="py-16 md:py-24 bg-gradient-to-br from-[#F8F9FA] to-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-12 md:mb-16">
          <div className="inline-flex items-center gap-2 bg-[#F59E0B]/10 px-6 py-3 rounded-full mb-6">
            <i className="ri-file-chart-line text-[#F59E0B] text-xl"></i>
            <span className="text-[#F59E0B] font-semibold text-sm">Documentos Profesionales</span>
          </div>
          <h2 className="text-3xl md:text-4xl lg:text-5xl font-bold text-[#1A1A2E] mb-4 md:mb-6 px-4">
            Nuestros Resultados
          </h2>
          <p className="text-base md:text-xl text-gray-500 max-w-3xl mx-auto leading-relaxed px-4">
            Entregamos documentos profesionales y detallados que facilitan la gestión académica de tu institución
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-6 md:gap-8 mb-12 md:mb-16">
          {documents.map((doc) => (
            <div
              key={doc.id}
              className="bg-white rounded-2xl shadow-lg overflow-hidden hover:shadow-2xl transition-all duration-300 border border-gray-100 group"
            >
              <div className="relative">
                <img
                  src={doc.image}
                  alt={doc.title}
                  className="w-full h-80 object-contain bg-gray-50 cursor-pointer"
                  onClick={() => setSelectedDoc(doc.image)}
                />
                <div className="absolute inset-0 bg-black/0 group-hover:bg-black/10 transition-all duration-300 flex items-center justify-center">
                  <button
                    onClick={() => setSelectedDoc(doc.image)}
                    className="opacity-0 group-hover:opacity-100 bg-white text-[#1A1A2E] px-6 py-3 rounded-full font-semibold shadow-lg transition-all inline-flex items-center gap-2 whitespace-nowrap cursor-pointer"
                  >
                    <i className="ri-zoom-in-line text-xl"></i>
                    Ver Ampliado
                  </button>
                </div>
              </div>
              
              <div className="p-6 md:p-8">
                <h3 className="text-xl md:text-2xl font-bold text-[#1A1A2E] mb-2 md:mb-3">
                  {doc.title}
                </h3>
                <p className="text-sm md:text-base text-gray-500 mb-5 md:mb-6 leading-relaxed">
                  {doc.description}
                </p>
                
                <div className="space-y-3">
                  <p className="text-sm font-semibold text-[#1A1A2E] mb-3">
                    Características:
                  </p>
                  {doc.features.map((feature, index) => (
                    <div key={index} className="flex items-start gap-3">
                      <div className="w-6 h-6 bg-[#0D9488]/15 rounded-full flex items-center justify-center flex-shrink-0 mt-0.5">
                        <i className="ri-check-line text-[#0D9488] text-sm"></i>
                      </div>
                      <p className="text-gray-600 text-sm">{feature}</p>
                    </div>
                  ))}
                </div>
              </div>
            </div>
          ))}
        </div>

        <div className="bg-gradient-to-br from-[#1A1A2E] to-[#2D2D44] rounded-3xl p-8 md:p-12 text-center relative overflow-hidden">
          <div className="absolute top-0 right-0 w-64 h-64 bg-[#0D9488]/10 rounded-full blur-3xl"></div>
          <div className="absolute bottom-0 left-0 w-64 h-64 bg-[#F59E0B]/10 rounded-full blur-3xl"></div>
          <div className="relative max-w-3xl mx-auto">
            <div className="w-16 h-16 md:w-20 md:h-20 bg-gradient-to-br from-[#0D9488] to-[#0F766E] rounded-2xl flex items-center justify-center mx-auto mb-5 md:mb-6">
              <i className="ri-file-list-3-line text-3xl md:text-4xl text-white"></i>
            </div>
            <h3 className="text-2xl md:text-3xl lg:text-4xl font-bold text-white mb-3 md:mb-4 px-4">
              Documentos Personalizados
            </h3>
            <p className="text-base md:text-xl text-white/80 mb-6 md:mb-8 leading-relaxed px-4">
              Todos nuestros documentos pueden ser personalizados con el logo y colores de tu institución, manteniendo siempre la máxima calidad y profesionalismo
            </p>
            <div className="flex flex-wrap justify-center gap-3 md:gap-4">
              <div className="bg-[#0D9488]/20 border border-[#0D9488]/30 px-4 md:px-6 py-2 md:py-3 rounded-full">
                <p className="text-white font-semibold text-xs md:text-sm">✓ Formato PDF de alta calidad</p>
              </div>
              <div className="bg-[#F59E0B]/20 border border-[#F59E0B]/30 px-4 md:px-6 py-2 md:py-3 rounded-full">
                <p className="text-white font-semibold text-xs md:text-sm">✓ Entrega inmediata</p>
              </div>
              <div className="bg-[#0D9488]/20 border border-[#0D9488]/30 px-4 md:px-6 py-2 md:py-3 rounded-full">
                <p className="text-white font-semibold text-xs md:text-sm">✓ Diseño personalizable</p>
              </div>
            </div>
          </div>
        </div>
      </div>

      {selectedDoc && (
        <div 
          className="fixed inset-0 bg-black/90 z-50 flex items-center justify-center p-4"
          onClick={() => setSelectedDoc(null)}
        >
          <button
            onClick={() => setSelectedDoc(null)}
            className="absolute top-6 right-6 w-12 h-12 bg-white/20 hover:bg-white/30 rounded-full flex items-center justify-center transition-all cursor-pointer"
          >
            <i className="ri-close-line text-3xl text-white"></i>
          </button>
          <div className="max-w-6xl w-full max-h-[90vh] overflow-auto">
            <img
              src={selectedDoc}
              alt="Documento ampliado"
              className="w-full h-auto"
              onClick={(e) => e.stopPropagation()}
            />
          </div>
        </div>
      )}
    </section>
  );
}